export default __webpack_public_path__ + "static/media/Moster.469d8c43.png";